{
  "activity.action.reauthenticated": "Recent authentication refreshed",
  "auth.confirmPassword": "Confirm password",
  "auth.resetRequestFailed": "The reset request could not be sent. Try again.",
  "auth.validation.confirmRequired": "Confirm your password.",
  "auth.validation.displayNameMax": "Use at most {{count}} characters.",
  "auth.validation.emailInvalid": "Enter a valid email address.",
  "auth.validation.emailRequired": "Enter your email address.",
  "auth.validation.mfaCode": "Enter a six-digit authenticator code or a ten-character recovery code.",
  "auth.validation.passwordMax": "Use at most {{count}} characters.",
  "auth.validation.passwordMin": "Use at least {{count}} characters.",
  "auth.validation.passwordMismatch": "The passwords do not match.",
  "auth.validation.passwordRequired": "Enter your password.",
  "onboarding.assistant.connected": "Already connected",
  "onboarding.assistant.connected.hint": "Record that your assistant connection is ready.",
  "onboarding.assistant.later": "Connect later",
  "onboarding.assistant.later.hint": "Finish setup now and open connection settings afterwards.",
  "onboarding.assistant.skip": "Not now",
  "onboarding.assistant.skip.hint": "Keep Exognitos fully usable without an assistant connection.",
  "onboarding.assistantChoice": "Optional AI connection",
  "onboarding.bedtime": "Bedtime",
  "onboarding.capture": "Quick Capture",
  "onboarding.captureHint": "Save a thought now and decide what it means later.",
  "onboarding.captureText": "What is on your mind?",
  "onboarding.completeDescription": "Your choices are saved to your account and will follow you across sessions.",
  "onboarding.completeTitle": "Your workspace is ready",
  "onboarding.conflict": "This setup advanced in another session. The current step has been reloaded.",
  "onboarding.continue": "Continue",
  "onboarding.dailyReminderTime": "Daily planning time",
  "onboarding.dataAcknowledge": "I understand how my data and connected services are handled.",
  "onboarding.dataAcknowledgeHint": "You can change connections, export data or delete the account later in Settings.",
  "onboarding.dataAssistant": "An AI connection only receives the capabilities and data access that you explicitly grant.",
  "onboarding.dataControl": "Settings provides visible controls for connections, export and account deletion.",
  "onboarding.dataStored": "Your workspace content is stored under your account on this Exognitos server.",
  "onboarding.dataTitle": "Your data stays under your control",
  "onboarding.end": "End",
  "onboarding.enterApp": "Enter Exognitos",
  "onboarding.eyebrow": "Account setup",
  "onboarding.finish": "Finish setup",
  "onboarding.firstContentKind": "Start with one real thing",
  "onboarding.genericError": "This step could not be saved. Your choices are still here; try again.",
  "onboarding.loadError": "Setup could not be loaded",
  "onboarding.loadErrorDescription": "Check the connection and retry. Your completed steps are already saved.",
  "onboarding.locale": "Interface language",
  "onboarding.locale.en": "English",
  "onboarding.locale.tr": "Turkish",
  "onboarding.openAssistantSettings": "Open connection settings",
  "onboarding.progress": "Setup progress",
  "onboarding.progressStep": "Step {{current}} of {{total}}",
  "onboarding.project": "Project",
  "onboarding.projectHint": "Create a concrete outcome you want to move forward.",
  "onboarding.projectTitle": "First Project title",
  "onboarding.reminder.both": "Both",
  "onboarding.reminder.both.hint": "Keep daily planning and the weekly review visible.",
  "onboarding.reminder.daily": "Daily planning",
  "onboarding.reminder.daily.hint": "Receive a prompt to choose the day's focus.",
  "onboarding.reminder.none": "No reminders",
  "onboarding.reminder.none.hint": "Use Exognitos without scheduled prompts.",
  "onboarding.reminder.review": "Weekly review",
  "onboarding.reminder.review.hint": "Receive a prompt for the end-of-week reset.",
  "onboarding.reminderChoice": "Which prompts would help?",
  "onboarding.reviewReminderTime": "Weekly review time",
  "onboarding.sampleCreate": "Create sample Project",
  "onboarding.sampleCreated": "The labelled sample Project is in your workspace. Removing it moves it to Trash, where it can be restored.",
  "onboarding.sampleDescription": "Optional sample data is never mixed into setup silently. Create one labelled Project only if you want an example to explore.",
  "onboarding.sampleRemove": "Move sample to Trash",
  "onboarding.sampleTitle": "Optional sample data",
  "onboarding.savedAutomatically": "Each completed step is saved to your account.",
  "onboarding.sleepEnabled": "Show my usual sleep window",
  "onboarding.sleepHint": "This shades quiet time in planning; it is not health or medical data.",
  "onboarding.sleepWindow": "Sleep window",
  "onboarding.start": "Start",
  "onboarding.step.assistant.description": "Exognitos works on its own. Connecting an AI assistant is optional and remains permission-scoped.",
  "onboarding.step.assistant.title": "Choose how AI fits",
  "onboarding.step.data.description": "Know what is stored and what can leave before setup is complete.",
  "onboarding.step.data.title": "Understand your data controls",
  "onboarding.step.firstContent.description": "Create one canonical Project or Capture so the workspace begins with something that matters to you.",
  "onboarding.step.firstContent.title": "Put the first thing in its place",
  "onboarding.step.profile.description": "These account settings keep dates, language and wall-clock times consistent on every device.",
  "onboarding.step.profile.title": "Start in your own time",
  "onboarding.step.reminders.description": "Choose only the prompts that help. You can change them in Settings at any time.",
  "onboarding.step.reminders.title": "Decide when Exognitos should prompt you",
  "onboarding.step.schedule.description": "Define ordinary boundaries so planning can reflect your day instead of assuming one.",
  "onboarding.step.schedule.title": "Shape a realistic day",
  "onboarding.timezone": "IANA timezone",
  "onboarding.validation.dataAck": "Read and acknowledge the data explanation to finish.",
  "onboarding.validation.firstContent": "Enter a title or thought to create your first item.",
  "onboarding.validation.sleepWindow": "Choose different bedtime and wake times.",
  "onboarding.validation.timezone": "Enter a valid IANA timezone, such as Europe/Istanbul.",
  "onboarding.validation.workWindow": "Choose different start and end times for work.",
  "onboarding.wake": "Wake time",
  "onboarding.workWindow": "Usual work window",
  "security.reauth.cancel": "Cancel",
  "security.reauth.code": "Authenticator or recovery code",
  "security.reauth.codeHint": "A recovery code may be pasted with its separator.",
  "security.reauth.description": "Confirm your current credentials before changing a sensitive security setting.",
  "security.reauth.error": "Your credentials could not be verified.",
  "security.reauth.password": "Current password",
  "security.reauth.title": "Confirm it is you",
  "security.reauth.verify": "Verify and continue",
  "security.sessions.current": "This device",
  "security.sessions.description": "Review active browser sessions and sign out a device you no longer recognise.",
  "security.sessions.loadError": "Sessions could not be loaded",
  "security.sessions.revoke": "Sign out",
  "security.sessions.revokeError": "The session could not be signed out.",
  "security.sessions.title": "Signed-in devices",
  "security.sessions.unknownDevice": "Unknown browser",
  "security.sessions.unknownNetwork": "Network unavailable"
}
